
// export const TAX_COUNSELING_TYPE = [
//   { label: "일반", value: "0" },
//   { label: "익명", value: "1" },
// ]


export const COUNSELING_SEARCH_OPTIONS = [
  { label: "제목 + 내용", value: "titleAndContent" },
  { label: "제목", value: "title" },
  { label: "내용", value: "content" },
];

export const COUNSELING_CATEGORY_TYPES = [
  { label: "일반", value: "0" },
  { label: "공지", value: "1" },
  { label: "문의사항", value: "2" },
  { label: "급여", value: "3" },
  { label: "신고서", value: "4" },
  { label: "납부서", value: "5" },
  { label: "계약서", value: "6" },
  { label: "민원증명", value: "7" },
  { label: "세금신고", value: "8" },
];